import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Mail from "@material-ui/icons/Mail";
import { Link } from "react-router-dom";
import {
  Button,
  Typography,
  CircularProgress,
  IconButton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "../../../components/CustomInput/TextField";
import Alert from "../../../components/alert";
import authComponentStyles from "../../../assets/styles/components/authComponentStyles";

const useStyles = makeStyles((theme) => authComponentStyles(theme));

export default ({ authState, onResetPassword, redUrl }) => {
  const classes = useStyles();
  const [state, setState] = useState({
    email: "",
  });

  const handleChange = (event) => {
    setState({ ...state, [event.target.id]: event.target.value, typing: true });
  };

  const handleReset = () => {
    const { email } = state;
    onResetPassword(email);
    setState({ ...state, typing: false });
  };

  const { loading, error, message } = authState;

  return (
    <Box>
      <Grid container justifyContent="center" direction="column">
        <TextField
          label="Email"
          fullWidth
          onChange={handleChange}
          id="email"
          type="email"
          EndAdornment={() => <Mail />}
        />
        <br></br>
      </Grid>
      <Grid container justifyContent="center" direction="column">
        {error && !state.typing ? (
          <Alert type="error" message={message} title="" />
        ) : null}
        <Typography align="center">
          Remember an account?&nbsp;
          <Link to={`/login?redUrl=${redUrl}`} className={classes.link}>
            Login instead
          </Link>
        </Typography>
        <br></br>
        {loading ? (
          <CircularProgress
            variant="indeterminate"
            className={classes.progress}
          />
        ) : null}
        <Button
          onClick={handleReset}
          disabled={loading}
          className={classes.loginButton}
        >
          Reset Password
        </Button>
      </Grid>
    </Box>
  );
};
